export const query1300 = `(max-width: 1300px)`;

export const query800 = `(max-width: 800px)`;

export const query500 = `(max-width: 500px)`;
